import { IMarket } from "../../hooks/api/aevo/useMarkets";

interface IManualWithdrawalLike {
  amount: string;
  collateral: string;
}

export const MANUAL_WITHDRAWAL_RESTRICTED_APPROVER_EMAIL =
  "muhammad@ribbon.finance";
export const MANUAL_WITHDRAWAL_APPROVAL_CAP_USD = 10000;

const normalizeCollateral = (collateral: string) => {
  if (collateral === "WETH") {
    return "ETH";
  }

  if (collateral === "WBTC") {
    return "BTC";
  }

  return collateral;
};

export const isRestrictedManualWithdrawalApprover = (email?: string) =>
  email === MANUAL_WITHDRAWAL_RESTRICTED_APPROVER_EMAIL;

export const getManualWithdrawalUsdValue = (
  withdrawal: IManualWithdrawalLike,
  markets?: Pick<IMarket, "underlying_asset" | "mark_price">[]
) => {
  const collateral = normalizeCollateral(withdrawal.collateral);

  if (collateral.includes("USD")) {
    return Number(withdrawal.amount);
  }

  const market = markets?.find((item) => item.underlying_asset === collateral);
  if (!market) {
    return undefined;
  }

  return Number(market.mark_price) * Number(withdrawal.amount);
};

export const getManualWithdrawalsUsdValue = (
  withdrawals: IManualWithdrawalLike[],
  markets?: Pick<IMarket, "underlying_asset" | "mark_price">[]
) =>
  withdrawals.reduce<number | undefined>((total, withdrawal) => {
    if (total === undefined) {
      return undefined;
    }

    const usdValue = getManualWithdrawalUsdValue(withdrawal, markets);
    if (usdValue === undefined) {
      return undefined;
    }

    return total + usdValue;
  }, 0);

export const getManualWithdrawalApprovalDisabledReason = (
  usdValue?: number
) => {
  if (usdValue === undefined) {
    return "Withdrawal USD value unavailable. Wait for market data to load.";
  }

  if (usdValue > MANUAL_WITHDRAWAL_APPROVAL_CAP_USD) {
    return "Muhammad can only approve manual withdrawals up to $10,000.";
  }

  return undefined;
};

export const getManualWithdrawalUnflagDisabledReason = (
  totalUsdValue?: number
) => {
  if (totalUsdValue === undefined) {
    return "Pending withdrawal USD value unavailable. Wait for market data to load.";
  }

  if (totalUsdValue > MANUAL_WITHDRAWAL_APPROVAL_CAP_USD) {
    return "Muhammad can only unflag accounts with $10,000 or less in pending manual withdrawals.";
  }

  return undefined;
};
